define(['app'], function (app) {
  var RankModel = app.Backbone.Model.extend({
    defaults: {
      isBold: false,
      isItalic: false,
      isUnderline: false,
      icon: '',
      avatarIcon: '',
      name: '',
      color: '',
      id: null
    }
  })

  return app.Backbone.Model.extend({
    defaults: {
      url: '',
      name: '',
      id: null,
      avatar: '',
      rank: RankModel,
      visible: true,
      selected: false
    }
  })
})
